export const translations = {
  en: {
    // Header
    home: "Home",
    restaurants: "Restaurants",
    categories: "Categories",
    familyDeals: "Family Deals",
    howItWorks: "How it works",
    help: "Help",
    partner: "Partner",
    basket: "Basket",
    search: "Search",
    admin: "Admin",
    // Hero
    heroTitle: "Hungry? We've got you covered.",
    heroSubtitle: "Order delicious food from local restaurants and have it delivered straight to your hotel, apartment or villa in Caleta de Fuste.",
    orderFood: "ORDER FOOD",
    browseRestaurants: "BROWSE RESTAURANTS",
    whereStaying: "Where are you staying?",
    hotel: "Hotel",
    apartment: "Apartment",
    villa: "Villa",
    other: "Other",
    hungryFor: "What are you hungry for?",
    featuredRestaurants: "Featured restaurants",
    viewAll: "View all",
    // Restaurant
    viewMenu: "VIEW MENU",
    open: "Open",
    closed: "Closed",
    minOrder: "Min. order",
    deliveryFee: "Delivery",
    deliveryTime: "Delivery time",
    rating: "Rating",
    cuisine: "Cuisine",
    // Cart
    yourBasket: "Your Basket",
    emptyBasket: "Your basket is empty.",
    startOrdering: "Start ordering from a restaurant",
    subtotal: "Food subtotal",
    serviceFee: "Service fee",
    total: "Total",
    proceedCheckout: "PROCEED TO CHECKOUT",
    addToBasket: "ADD TO BASKET",
    remove: "Remove",
    // Checkout
    whereDeliver: "Where should we deliver?",
    continueGuest: "Continue as guest",
    firstName: "First name",
    lastName: "Last name",
    email: "Email",
    phone: "Phone number",
    accommodationType: "Accommodation type",
    accommodationName: "Accommodation name",
    roomNumber: "Room / Apartment number",
    address: "Street / Address",
    deliveryInstructions: "Delivery instructions",
    deliveryInstructionsPh: "Please leave the order at reception.",
    useLocation: "Use my current location",
    whenFood: "When would you like your food?",
    asap: "ASAP",
    payment: "Payment",
    orderNow: "Order now and relax. We'll deliver it when you want it.",
    placeOrder: "PLACE ORDER",
    // Confirmation
    orderConfirmed: "ORDER CONFIRMED",
    thankYou: "Thank you for your order!",
    orderNumber: "Order number",
    estimatedDelivery: "Estimated delivery",
    trackOrder: "Track your order",
    // Tracking
    yourOrder: "Your order",
    orderReceived: "Order received",
    restaurantConfirmed: "Restaurant confirmed",
    beingPrepared: "Food being prepared",
    driverCollecting: "Driver collecting your order",
    onTheWay: "On the way",
    delivered: "Delivered",
    estimatedArrival: "Estimated arrival",
    contactSupport: "CONTACT SUPPORT",
    // Tourist section
    touristTitle: "Enjoy your holiday. We'll handle dinner.",
    touristText: "No cooking. No queues. No stress. Order your favourite food and have it delivered directly to your holiday accommodation in Caleta de Fuste.",
    // How it works
    hiwStep1Title: "Choose your food",
    hiwStep1Desc: "Browse local restaurants in Caleta de Fuste.",
    hiwStep2Title: "Tell us where you're staying",
    hiwStep2Desc: "Hotel, apartment or villa.",
    hiwStep3Title: "Choose your delivery time",
    hiwStep3Desc: "Order now or schedule your dinner for later.",
    hiwStep4Title: "Relax",
    hiwStep4Desc: "We'll get your food to you.",
    // Partner
    partnerTitle: "Get more orders from tourists in Caleta de Fuste.",
    partnerText: "Join Caleta Eats and let holidaymakers discover your restaurant online.",
    becomePartner: "BECOME A PARTNER",
    // Help
    helpTitle: "Help & Support",
    // Common
    slogan: "Food delivered to your holiday.",
    tagline: "Order food in Caleta de Fuste.",
    quickFilters: "Filter by cuisine",
    all: "All",
    filters: "Filters",
    scanOrderRelax: "Hungry? Scan. Order. Relax.",
    scanText: "Food delivery made easy in Caleta de Fuste.",
    filterSearch: "Search restaurants...",
    orderLater: "Schedule delivery",
    immediate: "Immediate delivery",
    close: "Close",
    edit: "Edit",
    qty: "Qty",
    save: "Save",
    delete: "Delete",
    add: "Add",
    cancel: "Cancel",
    price: "Price",
    name: "Name",
    description: "Description",
    category: "Category",
    image: "Image URL",
    dashboardOrders: "Today's Orders",
    revenue: "Revenue",
    orderCount: "Orders",
    byStatus: "By status",
    promoCode: "Promo code",
    apply: "Apply",
    invalidPromo: "Invalid or expired code",
    orderPlaced: "Order placed successfully!",
    fillRequired: "Please fill in all required fields",
    minOrderError: "Order below minimum",
    // QR Landing
    qrEyebrow: "Room service, reinvented",
    qrHeadline1: "Scan.",
    qrHeadline2: "Order.",
    qrHeadline3: "Relax.",
    qrSubtitle: "Great food from Caleta de Fuste's best kitchens — delivered straight to your room in 30 minutes.",
    qrCtaOrder: "Order now",
    qrCtaHow: "How it works",
    qrWelcomeAt: "Welcome to",
    qrTrust: "500+ happy holidaymakers this month",
    qrPerk1Title: "Right to your door",
    qrPerk1Desc: "Hotel, apartment or villa",
    qrPerk2Title: "30-min delivery",
    qrPerk2Desc: "Hot & fresh, guaranteed",
    qrPerk3Title: "Pay on arrival",
    qrPerk3Desc: "Cash or card, no fuss",
    qrPerk4Title: "No sign-up",
    qrPerk4Desc: "Order as a guest, in one tap",
    qrHowTitle: "How it works",
    qrStep1Title: "Pick a restaurant",
    qrStep1Desc: "Browse local menus in your language.",
    qrStep2Title: "Tell us your room",
    qrStep2Desc: "No account, no paperwork.",
    qrStep3Title: "We deliver, you feast",
    qrStep3Desc: "Live tracking until it arrives.",
    qrTasteTitle: "A taste of Caleta",
    qrFooter: "Made for tourists in Caleta de Fuste",
    // Customisation
    customiseTitle: "Customise",
    customiseHint: "Tap to remove",
    addonsTitle: "Extra add-ons",
    no: "No",
    without: "Without",
    deliveryHintAdd: "Add",
    deliveryHintFor: "for",
    deliveryHintDelivery: "delivery",
    deliveryHintUnlocked: "You unlocked €2.99 delivery!",
    deliveryTiered: "€2.99 delivery on orders ≥ €20 — otherwise €4.99",
  },
  it: {
    home: "Home",
    restaurants: "Ristoranti",
    categories: "Categorie",
    familyDeals: "Offerte Famiglia",
    howItWorks: "Come funziona",
    help: "Aiuto",
    partner: "Partner",
    basket: "Carrello",
    search: "Cerca",
    admin: "Admin",
    heroTitle: "Fame? Ci pensiamo noi.",
    heroSubtitle: "Ordina cibo delizioso dai ristoranti locali e ricevilo direttamente nel tuo hotel, appartamento o villa a Caleta de Fuste.",
    orderFood: "ORDINA CIBO",
    browseRestaurants: "SFOGLIA I RISTORANTI",
    whereStaying: "Dove alloggi?",
    hotel: "Hotel",
    apartment: "Appartamento",
    villa: "Villa",
    other: "Altro",
    hungryFor: "Cosa ti va di mangiare?",
    featuredRestaurants: "Ristoranti in evidenza",
    viewAll: "Vedi tutti",
    viewMenu: "VEDI MENU",
    open: "Aperto",
    closed: "Chiuso",
    minOrder: "Ordine min.",
    deliveryFee: "Consegna",
    deliveryTime: "Tempo di consegna",
    rating: "Valutazione",
    cuisine: "Cucina",
    yourBasket: "Il tuo carrello",
    emptyBasket: "Il tuo carrello è vuoto.",
    startOrdering: "Inizia a ordinare da un ristorante",
    subtotal: "Subtotale",
    serviceFee: "Costo servizio",
    total: "Totale",
    proceedCheckout: "VAI AL CHECKOUT",
    addToBasket: "AGGIUNGI AL CARRELLO",
    remove: "Rimuovi",
    whereDeliver: "Dove consegnare?",
    continueGuest: "Continua come ospite",
    firstName: "Nome",
    lastName: "Cognome",
    email: "Email",
    phone: "Telefono",
    accommodationType: "Tipo di alloggio",
    accommodationName: "Nome alloggio",
    roomNumber: "Numero camera / appartamento",
    address: "Via / Indirizzo",
    deliveryInstructions: "Istruzioni di consegna",
    deliveryInstructionsPh: "Lasciare l'ordine alla reception.",
    useLocation: "Usa la mia posizione",
    whenFood: "Quando vuoi il tuo cibo?",
    asap: "SUBITO",
    payment: "Pagamento",
    orderNow: "Ordina ora e rilassati. Consegniamo quando vuoi.",
    placeOrder: "CONFERMA ORDINE",
    orderConfirmed: "ORDINE CONFERMATO",
    thankYou: "Grazie per il tuo ordine!",
    orderNumber: "Numero ordine",
    estimatedDelivery: "Consegna stimata",
    trackOrder: "Segui il tuo ordine",
    yourOrder: "Il tuo ordine",
    orderReceived: "Ordine ricevuto",
    restaurantConfirmed: "Ristorante ha confermato",
    beingPrepared: "In preparazione",
    driverCollecting: "Il rider sta ritirando l'ordine",
    onTheWay: "In consegna",
    delivered: "Consegnato",
    estimatedArrival: "Arrivo stimato",
    contactSupport: "CONTATTA IL SUPPORTO",
    touristTitle: "Goditi la vacanza. Alla cena pensiamo noi.",
    touristText: "Niente cucina. Niente code. Niente stress. Ordina il tuo cibo preferito e ricevilo direttamente nel tuo alloggio a Caleta de Fuste.",
    hiwStep1Title: "Scegli il cibo",
    hiwStep1Desc: "Sfoglia i ristoranti locali di Caleta de Fuste.",
    hiwStep2Title: "Dicci dove alloggi",
    hiwStep2Desc: "Hotel, appartamento o villa.",
    hiwStep3Title: "Scegli l'orario di consegna",
    hiwStep3Desc: "Ordina ora o programma la cena.",
    hiwStep4Title: "Rilassati",
    hiwStep4Desc: "Ti portiamo tutto noi.",
    partnerTitle: "Ricevi più ordini dai turisti di Caleta de Fuste.",
    partnerText: "Unisciti a Caleta Eats e fai scoprire il tuo ristorante ai vacanzieri.",
    becomePartner: "DIVENTA PARTNER",
    helpTitle: "Aiuto e Supporto",
    slogan: "Cibo consegnato alla tua vacanza.",
    tagline: "Ordina cibo a Caleta de Fuste.",
    quickFilters: "Filtra per cucina",
    all: "Tutti",
    filters: "Filtri",
    scanOrderRelax: "Fame? Scansiona. Ordina. Rilassati.",
    scanText: "Food delivery facile a Caleta de Fuste.",
    filterSearch: "Cerca ristoranti...",
    orderLater: "Programma la consegna",
    immediate: "Consegna immediata",
    close: "Chiudi",
    edit: "Modifica",
    qty: "Qtà",
    save: "Salva",
    delete: "Elimina",
    add: "Aggiungi",
    cancel: "Annulla",
    price: "Prezzo",
    name: "Nome",
    description: "Descrizione",
    category: "Categoria",
    image: "URL Immagine",
    dashboardOrders: "Ordini di oggi",
    revenue: "Incasso",
    orderCount: "Ordini",
    byStatus: "Per stato",
    promoCode: "Codice sconto",
    apply: "Applica",
    invalidPromo: "Codice non valido o scaduto",
    orderPlaced: "Ordine effettuato con successo!",
    fillRequired: "Compila tutti i campi richiesti",
    minOrderError: "Ordine sotto il minimo",
    // QR Landing
    qrEyebrow: "Room service, reinventato",
    qrHeadline1: "Scansiona.",
    qrHeadline2: "Ordina.",
    qrHeadline3: "Rilassati.",
    qrSubtitle: "Il meglio delle cucine di Caleta de Fuste — consegnato direttamente in camera in 30 minuti.",
    qrCtaOrder: "Ordina ora",
    qrCtaHow: "Come funziona",
    qrWelcomeAt: "Benvenuto al",
    qrTrust: "500+ turisti soddisfatti questo mese",
    qrPerk1Title: "Consegna in camera",
    qrPerk1Desc: "Hotel, appartamento o villa",
    qrPerk2Title: "Consegna in 30 min",
    qrPerk2Desc: "Caldo e fresco, garantito",
    qrPerk3Title: "Paghi alla consegna",
    qrPerk3Desc: "Contanti o carta, semplice",
    qrPerk4Title: "Nessuna registrazione",
    qrPerk4Desc: "Ordina come ospite, in un tap",
    qrHowTitle: "Come funziona",
    qrStep1Title: "Scegli un ristorante",
    qrStep1Desc: "Sfoglia i menu locali nella tua lingua.",
    qrStep2Title: "Indica la tua camera",
    qrStep2Desc: "Niente account, niente moduli.",
    qrStep3Title: "Consegniamo, tu ti godi la cena",
    qrStep3Desc: "Tracciamento live fino alla porta.",
    qrTasteTitle: "Un assaggio di Caleta",
    qrFooter: "Pensato per i turisti a Caleta de Fuste",
    // Customisation
    customiseTitle: "Personalizza",
    customiseHint: "Tocca per rimuovere",
    addonsTitle: "Ingredienti extra",
    no: "No",
    without: "Senza",
    deliveryHintAdd: "Aggiungi",
    deliveryHintFor: "per la consegna a",
    deliveryHintDelivery: "",
    deliveryHintUnlocked: "Hai sbloccato la consegna a €2,99!",
    deliveryTiered: "Consegna a €2,99 per ordini ≥ €20 — altrimenti €4,99",
  },
  es: {
    home: "Inicio",
    restaurants: "Restaurantes",
    categories: "Categorías",
    familyDeals: "Ofertas Familia",
    howItWorks: "Cómo funciona",
    help: "Ayuda",
    partner: "Socio",
    basket: "Cesta",
    search: "Buscar",
    admin: "Admin",
    heroTitle: "¿Hambre? Nosotros nos ocupamos.",
    heroSubtitle: "Pide comida deliciosa de restaurantes locales y recíbela directamente en tu hotel, apartamento o villa en Caleta de Fuste.",
    orderFood: "PEDIR COMIDA",
    browseRestaurants: "VER RESTAURANTES",
    whereStaying: "¿Dónde te alojas?",
    hotel: "Hotel",
    apartment: "Apartamento",
    villa: "Villa",
    other: "Otro",
    hungryFor: "¿Qué te apetece?",
    featuredRestaurants: "Restaurantes destacados",
    viewAll: "Ver todo",
    viewMenu: "VER MENÚ",
    open: "Abierto",
    closed: "Cerrado",
    minOrder: "Pedido mín.",
    deliveryFee: "Envío",
    deliveryTime: "Tiempo de entrega",
    rating: "Valoración",
    cuisine: "Cocina",
    yourBasket: "Tu cesta",
    emptyBasket: "Tu cesta está vacía.",
    startOrdering: "Empieza a pedir en un restaurante",
    subtotal: "Subtotal comida",
    serviceFee: "Cargo por servicio",
    total: "Total",
    proceedCheckout: "IR AL PAGO",
    addToBasket: "AÑADIR A LA CESTA",
    remove: "Quitar",
    whereDeliver: "¿Dónde entregamos?",
    continueGuest: "Continuar como invitado",
    firstName: "Nombre",
    lastName: "Apellido",
    email: "Email",
    phone: "Teléfono",
    accommodationType: "Tipo de alojamiento",
    accommodationName: "Nombre del alojamiento",
    roomNumber: "Número habitación / apartamento",
    address: "Calle / Dirección",
    deliveryInstructions: "Instrucciones de entrega",
    deliveryInstructionsPh: "Por favor, dejar en recepción.",
    useLocation: "Usar mi ubicación",
    whenFood: "¿Cuándo quieres la comida?",
    asap: "AHORA",
    payment: "Pago",
    orderNow: "Pide ahora y relájate. Entregamos cuando quieras.",
    placeOrder: "REALIZAR PEDIDO",
    orderConfirmed: "PEDIDO CONFIRMADO",
    thankYou: "¡Gracias por tu pedido!",
    orderNumber: "Número de pedido",
    estimatedDelivery: "Entrega estimada",
    trackOrder: "Sigue tu pedido",
    yourOrder: "Tu pedido",
    orderReceived: "Pedido recibido",
    restaurantConfirmed: "Restaurante confirmado",
    beingPrepared: "Preparando comida",
    driverCollecting: "Repartidor recogiendo",
    onTheWay: "En camino",
    delivered: "Entregado",
    estimatedArrival: "Llegada estimada",
    contactSupport: "CONTACTAR SOPORTE",
    touristTitle: "Disfruta tus vacaciones. Nosotros nos ocupamos de la cena.",
    touristText: "Sin cocinar. Sin colas. Sin estrés. Pide tu comida favorita y recíbela directamente en tu alojamiento en Caleta de Fuste.",
    hiwStep1Title: "Elige tu comida",
    hiwStep1Desc: "Explora restaurantes locales en Caleta de Fuste.",
    hiwStep2Title: "Dinos dónde te alojas",
    hiwStep2Desc: "Hotel, apartamento o villa.",
    hiwStep3Title: "Elige la hora de entrega",
    hiwStep3Desc: "Pide ahora o programa la cena.",
    hiwStep4Title: "Relájate",
    hiwStep4Desc: "Te llevamos la comida.",
    partnerTitle: "Consigue más pedidos de turistas en Caleta de Fuste.",
    partnerText: "Únete a Caleta Eats y deja que los turistas descubran tu restaurante online.",
    becomePartner: "HAZTE SOCIO",
    helpTitle: "Ayuda y Soporte",
    slogan: "Comida a domicilio para tus vacaciones.",
    tagline: "Pide comida en Caleta de Fuste.",
    quickFilters: "Filtrar por cocina",
    all: "Todos",
    filters: "Filtros",
    scanOrderRelax: "¿Hambre? Escanea. Pide. Relájate.",
    scanText: "Comida a domicilio fácil en Caleta de Fuste.",
    filterSearch: "Buscar restaurantes...",
    orderLater: "Programar entrega",
    immediate: "Entrega inmediata",
    close: "Cerrar",
    edit: "Editar",
    qty: "Cant",
    save: "Guardar",
    delete: "Eliminar",
    add: "Añadir",
    cancel: "Cancelar",
    price: "Precio",
    name: "Nombre",
    description: "Descripción",
    category: "Categoría",
    image: "URL Imagen",
    dashboardOrders: "Pedidos de hoy",
    revenue: "Ingresos",
    orderCount: "Pedidos",
    byStatus: "Por estado",
    promoCode: "Código promo",
    apply: "Aplicar",
    invalidPromo: "Código no válido o caducado",
    orderPlaced: "¡Pedido realizado con éxito!",
    fillRequired: "Rellena todos los campos requeridos",
    minOrderError: "Pedido por debajo del mínimo",
    // QR Landing
    qrEyebrow: "Room service, reinventado",
    qrHeadline1: "Escanea.",
    qrHeadline2: "Pide.",
    qrHeadline3: "Relájate.",
    qrSubtitle: "Lo mejor de las cocinas de Caleta de Fuste — entregado directamente en tu habitación en 30 minutos.",
    qrCtaOrder: "Pedir ahora",
    qrCtaHow: "Cómo funciona",
    qrWelcomeAt: "Bienvenido al",
    qrTrust: "500+ turistas felices este mes",
    qrPerk1Title: "Entrega en tu habitación",
    qrPerk1Desc: "Hotel, apartamento o villa",
    qrPerk2Title: "Entrega en 30 min",
    qrPerk2Desc: "Caliente y fresco, garantizado",
    qrPerk3Title: "Paga al recibir",
    qrPerk3Desc: "Efectivo o tarjeta, sencillo",
    qrPerk4Title: "Sin registro",
    qrPerk4Desc: "Pide como invitado, con un toque",
    qrHowTitle: "Cómo funciona",
    qrStep1Title: "Elige un restaurante",
    qrStep1Desc: "Explora menús locales en tu idioma.",
    qrStep2Title: "Dinos tu habitación",
    qrStep2Desc: "Sin cuenta, sin papeleos.",
    qrStep3Title: "Entregamos, tú disfrutas",
    qrStep3Desc: "Seguimiento en vivo hasta la puerta.",
    qrTasteTitle: "Un sabor de Caleta",
    qrFooter: "Pensado para turistas en Caleta de Fuste",
    // Customisation
    customiseTitle: "Personaliza",
    customiseHint: "Toca para quitar",
    addonsTitle: "Ingredientes extra",
    no: "No",
    without: "Sin",
    deliveryHintAdd: "Añade",
    deliveryHintFor: "para envío a",
    deliveryHintDelivery: "",
    deliveryHintUnlocked: "¡Has desbloqueado el envío a €2.99!",
    deliveryTiered: "Envío a €2.99 en pedidos ≥ €20 — si no, €4.99",
  },
};

export const cuisineLabels = {
  en: {
    pizza: "Pizza", burgers: "Burgers", "fish-chips": "Fish & Chips",
    indian: "Indian", steak: "Steak", mexican: "Mexican",
    healthy: "Healthy", desserts: "Desserts", drinks: "Drinks", family: "Family Deals",
  },
  it: {
    pizza: "Pizza", burgers: "Hamburger", "fish-chips": "Fish & Chips",
    indian: "Indiano", steak: "Bistecca", mexican: "Messicano",
    healthy: "Salutare", desserts: "Dolci", drinks: "Bevande", family: "Offerte Famiglia",
  },
  es: {
    pizza: "Pizza", burgers: "Hamburguesas", "fish-chips": "Pescado y Patatas",
    indian: "Indio", steak: "Carnes", mexican: "Mexicano",
    healthy: "Saludable", desserts: "Postres", drinks: "Bebidas", family: "Ofertas Familia",
  },
};
